import React from "react";
import { SubHeading } from "../../components";

import { images } from "../../constants";

import "./Chef.css";

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="Chef" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Chef's Word" />
      <h1 className="headtext__cormorant">What we Believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote" />
          <p className="p__opensans">
            A chef's palate is born out of his childhood, and one thing all
            chefs have in common is a mother who can cook.
          </p>
        </div>
        <p className="p__opensans">
          If you're not the one cooking, stay out of the way and compliment the
          chef.
        </p>
      </div>
      <div className="app__chef-sign">
        <p>Tahiya Islam</p>
        <p className="p__opensans">Chef and Founder</p>
        <img src={images.sign} alt="sign" />
      </div>
    </div>
  </div>
);

export default Chef;
